module.exports = __webpack_public_path__ + "img/clock.fe4f6e5b.png";